import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CircularSpinner from '@shared/atoms/CircularSpinner';
import Table, { ORDER_TYPES } from '@shared/organisms/Table';
import T from '@shared/atoms/Typography';
import { newSelectTranslation } from '@shared/utils';

const SubscriptionsTab = ({ loading, subscriptions }) => {
  const { t } = useTranslation();

  return (
    <>
      {loading && <CircularSpinner static />}
      {subscriptions?.length > 0 && !loading && (
        <Table
          ariaLabel="Subscriptions table"
          columns={[
            {
              key: 'subscriptionPlanName',
              label: t('backoffice.users.subscription'),
            },
            {
              key: 'validFrom',
              label: t('backoffice.users.start'),
            },
            {
              key: 'expirationDate',
              label: t('backoffice.users.end'),
            },
          ]}
          items={subscriptions.map(({ product, ...rest }) => ({
            subscriptionPlanName: newSelectTranslation(product.name),
            ...rest,
          }))}
          defaultOrder={ORDER_TYPES.DESC}
          defaultOrderBy="validFrom"
        />
      )}
      {subscriptions?.length === 0 && !loading && (
        <T>{t('backoffice.users.noSubscriptionsFound')}</T>
      )}
    </>
  );
};

SubscriptionsTab.propTypes = {
  loading: PropTypes.bool.isRequired,
  subscriptions: PropTypes.array,
};

export default SubscriptionsTab;
